module.exports = {
  apiUrl: process.env.REACT_APP_API_URL || 'https://ifa-api-homolog-vidu.onrender.com/api'
}
